import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { User } from '@entity/user';
import { UserService } from '@service/user.service';

export const UserResolve: ResolveFn<User> = (route) => {
  return inject(UserService).getUser(route.params.id);
};
